import i18n from '../../language/index'
const imageAnimationList = [
  {
    id: 0,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2249'),
    formData: {
      effect: 0
    }
  },
  {
    id: 1,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2254'),
    formData: {
      effect: 0
    },
    effects: [i18n.t('components_my_animation_image_animation_list_2257'), i18n.t('components_my_animation_image_animation_list_2258')]
  },
  {
    id: 2,
    typeTitle: i18n.t('base_kindeditor_all_1633'),
    formData: {
      effect: 0,
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      }
    },
    effects: [i18n.t('components_my_animation_image_animation_list_2257'), i18n.t('components_my_animation_image_animation_list_2258'), i18n.t('components_my_animation_image_animation_list_2259'), i18n.t('components_my_animation_image_animation_list_2260')],
    border: true
  },
  {
    id: 3,
    typeTitle: i18n.t('components_my_animation_image_animation_list_2261'),
    formData: {
      direction: 'left'
    },
    direction: {
      left: i18n.t('components_my_animation_image_animation_list_2262'),
      right: i18n.t('components_my_animation_image_animation_list_2263'),
      top: i18n.t('components_basic_addproduct_sales_2138'),
      bottom: i18n.t('components_basic_addproduct_sales_2139')
    }
  },
  {
    id: 4,
    typeTitle: i18n.t('components_my_animation_image_animation_list_2264'),
    formData: {
      effect: 0,
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      }
    },
    effects: [i18n.t('components_my_animation_image_animation_list_2257'), i18n.t('components_my_animation_image_animation_list_2258')],
    background: true
  },
  {
    id: 5,
    typeTitle: i18n.t('components_my_animation_image_animation_list_2265'),
    formData: {
      effect: 0
    }
  }
]

export default imageAnimationList



// WEBPACK FOOTER //
// ./src/components/my_animation/image_animation_list.js